import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.SectionA');

    return (
        <div className={styles.comp} id="SectionA">
            <EcoSectionCard
                theme="black"
                layout="center-center"
                title={t('title')}
                pc="https://websiteoss.ecoflow.com/upload/image/1745458260117/A.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1745458261617/A-h5.jpg"
            />
        </div>
    );
}
